import React from 'react';
import { Link } from 'react-router-dom';
import Icon from './Icon';

/**
 * IconTile — circle-outlined icon with a label and optional sub-label.
 * Renders <Link> when `to`, <button> when `onClick`, else <div>.
 * size: sm | md | lg
 */
export default function IconTile({ icon, label, sub, to, href, onClick, size = 'md', className = '', ...rest }) {
  const cls = `icon-tile icon-tile--${size}${className ? ` ${className}` : ''}`;
  const inner = (
    <>
      <span className="icon-tile__ring"><Icon name={icon} size={size === 'lg' ? 28 : size === 'sm' ? 20 : 24} /></span>
      <span className="icon-tile__text">
        <span className="icon-tile__label">{label}</span>
        {sub && <span className="icon-tile__sub">{sub}</span>}
      </span>
    </>
  );
  if (to) return <Link to={to} className={cls} {...rest}>{inner}</Link>;
  if (href) return <a href={href} className={cls} target="_blank" rel="noopener noreferrer" {...rest}>{inner}</a>;
  if (onClick) return <button type="button" onClick={onClick} className={cls} {...rest}>{inner}</button>;
  return <div className={cls} {...rest}>{inner}</div>;
}
